import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import 'prop-types';
import * as React from 'react';
import { Svg } from '../Icon/Base.js';
import { jsx } from 'react/jsx-runtime';

var _excluded = ["color"];
var IconLink = /*#__PURE__*/React.memo(function (_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/jsx(Svg, _objectSpread(_objectSpread({
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      d: "M8.522 11.735a4.47 4.47 0 00-3.416 1.295l-1.061 1.061a4.5 4.5 0 106.364 6.364l1.06-1.06a4.474 4.474 0 001.296-3.418M11.235 9.022a4.469 4.469 0 011.295-3.416l1.061-1.061a4.5 4.5 0 116.364 6.364l-1.06 1.06a4.472 4.472 0 01-3.417 1.296M8.287 16.212l7.424-7.425",
      stroke: color,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  }));
});
IconLink.displayName = "IconLink";

export { IconLink };
